import * as React from "react";
export var TrackerContext = React.createContext({
    callTrackLoadPage: function () { },
    callTrackUnLoadPage: function () { },
});
export default TrackerContext;
//# sourceMappingURL=TrackerContext.js.map